module.exports = __webpack_public_path__ + "img/avatar.2920a2e2.png";